/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Fc_Home_Review_Con4Inputs */

const en_fc_home_review_con4 = /** @type {(inputs: Fc_Home_Review_Con4Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Very large footage can feel slow, because color grading and export rendering still run on the CPU.`)
};

/**
* | output |
* | --- |
* | "Very large footage can feel slow, because color grading and export rendering still run on the CPU." |
*
* @param {Fc_Home_Review_Con4Inputs} inputs
* @param {{ locale?: "en" }} options
* @returns {LocalizedString}
*/
const fc_home_review_con4 = /** @type {((inputs?: Fc_Home_Review_Con4Inputs, options?: { locale?: "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Fc_Home_Review_Con4Inputs, { locale?: "en" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return en_fc_home_review_con4(inputs)
});
export { fc_home_review_con4 as "fc.home.review.con4" }